import { module } from 'modujs';
import { html } from '../utils/environment'

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        if(!window.localStorage.getItem('lyft-cookie-banner')) {
            html.classList.add('has-cookie-banner')

            this.closeBind = () => {
                html.classList.remove('has-cookie-banner')
                window.localStorage.setItem('lyft-cookie-banner', 'dismissed')
            }

            this.$('close')[0].addEventListener('click', this.closeBind)
        }
    }
}
